import { Component, OnInit, Input } from '@angular/core';
import { FormElementSocialMedia } from '../shared/model/social-media/form-element-social-media.model';
import { FormFields } from '../shared/service/form-fields.service';
import { FormElementSocialMediaType } from '../shared/model/social-media/form-element-social-media-type.model';

@Component({
  selector: 'wl-form-builder-social-media-edit-element',
  templateUrl: 'form-builder-social-media-edit-element.component.html',
    standalone: false
})
export class FormBuilderSocialMediaEditElementComponent {
  public socialMediaSettings: FormElementSocialMedia;
  private _allFields: Array<FormElementSocialMediaType>;

  public constructor(private _formFieldsService: FormFields) {
    this.socialMediaSettings = new FormElementSocialMedia();
    this._allFields = [];
  }

  ngOnInit(): void {}

  // get any fields that might not already be in the array
  refetchSocialMedia(): void {
    if (this._allFields.length) return;
    this._formFieldsService.getActiveSocialMediaTypes().then((data: any) => {
      this._allFields = data.Result.map((x: any) => {
        let field = new FormElementSocialMediaType();
        field.SocialMediaTypeId = x.SocialMediaTypeID;
        field.Name = x.Name;
        return field;
      });

      // add any fields that aren't already in the array
      this._allFields.forEach((x: any) => {
        let foundField = this.socialMediaSettings.SocialMediaFields.find(f => {
          return f.SocialMediaTypeId.toString() == x.SocialMediaTypeId.toString();
        });
        if (foundField == null) this.socialMediaSettings.SocialMediaFields.push(x);
      });

      this.socialMediaSettings.SocialMediaFields = this.socialMediaSettings.SocialMediaFields.sort((a, b) => {
        if (a.Name > b.Name) return 1;
        if (a.Name < b.Name) return -1;
        return 0;
      });
    });
  }
}
